import { ja } from "vuetify/src/locale";
export default {
  ...ja
};
